import React from "react";

export default function StarIconActiveYellow(props) {
  return (
    <svg width={12} height={11} viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 3.5L6 0.5L4 3.5L0.5 4.5L3 7L2.5 10.5L6 9L9.5 11L9 7L11.5 4L8 3.5Z" fill="#FFAA15" />
    </svg>
  );
}
